import React from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { maxWidth } from '../../helpers/media-queries';


const styles = ({ palette }) => ({
    root: {
        position: 'relative',
        '& .container': {
            position: 'relative',
            border: 'none',

            padding: '0 75px 25px',
            maxWidth: '1080px',
            borderLeft: '8px solid #001c28',
            borderRight: '8px solid #001c28',
            backgroundColor: '#005072',

            color: '#288ab4',
            textAlign: 'center',

            '& a': {
                color: 'inherit',
                borderBottom: '1px solid currentColor',
                '&:hover': {
                    textDecoration: 'none',
                }
            }
        },
        [maxWidth.lg]: {
            '& .container': {
                borderWidth: '5.5px',
                padding: '15px',
                '& span': {
                    display: 'block',
                }
            }
        },
        [maxWidth.sm]: {
            '& .container': {
                borderWidth: '2.5px',
                padding: '15px',
                '& span': {
                    display: 'block',
                }
            }
        }
    }
});

const mapper = (stores, props) => ({
    intl: stores.intl.dictionary,

    report: (e) => stores.analytics.report(e),
    
    /** post message events */
    score: ({score}) => stores.ranking.score(score),
    share: ({platform, score}) => stores.social.share(platform, score),
    register: (ev) => {    
        return stores.analytics.event(Object.assign({
            category: 'Game',
            action: 'Play',
        }, ev));
    },
    updateRanking: () => stores.ranking.fetchRanking(),
    // setFullscreen: (fullscreen) => stores.ui.setFullscreen(fullscreen),
})

const Footer = ({ classes }) => (
    <footer className={classes.root}>
        <div className="container">
            Deadly Arcade by <a href="http://pushstart.com.br/" target="_blank" rel="noopener noreferrer" >PushStart</a>. <span>© 2019 20th Century Fox. All rights reserved</span>
        </div>
    </footer>
)

export default inject(mapper)(
    withStyles(styles)(Footer)
);